import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Keeps <html lang> in sync with the active language on EVERY route.
//
// Why this exists: each page used to set `document.documentElement.lang` in its
// own effect, and the client-only routes (/dashboard, /account, /help) never
// did. i18n/config.ts sets it too, but only inside the changeLanguage handler —
// so on a fresh load of the dashboard it never ran and the attribute stayed
// EMPTY. A screen reader then reads a fully French UI with an English voice.
// That is WCAG 3.1.1 (Language of Page), Level A, on the primary surface of a
// product built for accessibility in a French-first market.
//
// Mounted once at the app root so it covers routes added later by default,
// rather than relying on every new page to remember.
export function useHtmlLang(): void {
  const { i18n } = useTranslation();

  useEffect(() => {
    const tag = i18n.language?.startsWith('fr') ? 'fr-CA' : 'en';
    if (document.documentElement.lang !== tag) {
      document.documentElement.lang = tag;
    }
  }, [i18n.language]);
}
